<template>
  <div class="slides">
    <div 
      v-for="(image, index) in images"
      class="slides__slide" 
      :style="{
        'animationDelay': `${index * animationFactor}s`,
        'zIndex': images.length - index,
        'animationDuration': `${images.length * animationFactor}s`,
        'backgroundImage': index === 0 || load ? `url(${image})` : '',
        'visibility': index > 0 ? 'hidden' : 'visible'
      }"
    >
    </div>
    <span class="slides__title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'hover-show',
  props: ['images', 'title'],
  data () {
    return {
      animationFactor: 0.4,
      load: false
    }
  },
  mounted () {
    this.loadImagesIfNoTouch()
  },
  methods: {
    loadImagesIfNoTouch () {
      if (window.isTouch) return
      this.$nextTick(function () {
        this.load = true
      })
    }
  }
}
</script>

<style lang="sass">

@import "../assets/sass/utilities/variables"
@import "../assets/sass/utilities/mixins"

.slides
  width: 100%
  height: 100%
  position: relative
  margin: 0 auto
  overflow: hidden

.slides__slide
  top: 0
  left: 0
  width: 100%
  height: 100%
  position: absolute
  animation: show-slide linear infinite 0s forwards
  animation-play-state: paused
  background-size: cover
  background-position: center

.slides__title
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba($red, 0.8)
  color: $white
  z-index: 1000
  opacity: 0
  font-weight: 500
  display: flex
  justify-content: center
  align-items: center
  // .slides:hover &
    // opacity: 1

// .no-touch .slides:hover .slides__slide
  animation-play-state: running

// .no-touch .slides .slides__slide
  animation-play-state: running

@keyframes show-slide
  0%, 12.5%
    visibility: visible
    z-index: 100 
  25%, 100%
    visibility: hidden
    z-index: 0

</style>




// WEBPACK FOOTER //
// HoverShow.vue?acfb9850